import {Injectable} from '@angular/core';
import {GeneralServicesImplService} from '../../../../services/general-services-impl.service';
import {HttpClient} from '@angular/common/http';
import * as servers from '../../../../services/api/servers';
import {urls} from '../../../../services/api/urls';
import {Observable} from 'rxjs';
import {ProjectConstants} from '../../../project-constants';

@Injectable({
  providedIn: 'root'
})

export class ConsuntivoForecastUploadService extends GeneralServicesImplService {
  constructor(http: HttpClient) {
    super(http);
  }

  baseUrl: string = servers.apiUrl + urls.forecastController;

  uploadConsumptiveForecast(file: FormData, numAnnoMese: number, providerCod: string, status: string): Observable<any> {
    const url = this.baseUrl + this.LINKS.UPLOAD_CONSUMPTIVE_FORECAST
                             + '/' + numAnnoMese.toString()
                             + '/' + providerCod
                             + '/' + status;
    const body =  file;
    const header = ProjectConstants.returnHeaderBlank();
    return this.http.post( url, body, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

}
